export enum PedigreeGender {
  female = 0,
  male = 1,
  unknown = 2,
}